module.exports = __webpack_public_path__ + "static/media/app_badge_xros.e23c6fad.png";